import React from 'react';
import cx from 'classnames';
import styles from './style.module.css';

export const Divider = ({ className }: { className?: string }) => {
  return <div className={cx('db w-100 bg-alto bn', styles.dividerClass, className)} />;
};
